import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useSearch } from "@tanstack/react-router";

import { forgetMediaAccess } from "../../platform/media/access";
import { wayBack } from "../../platform/session";
import { AuthShell } from "../../ui/AuthShell";
import { SignInChoices } from "./SignInChoices";

/** Google or an email code, nothing else (D1). There is no sign-up: an invitation is the way in. */
export function SignInScreen() {
  const { redirect } = useSearch({ from: "/sign-in" });
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const target = wayBack(redirect);
  const onSignedIn = () => {
    // A new session: nothing cached under the old one may show (audit frontend B.9), and no
    // media grant of it is asked on.
    queryClient.clear();
    forgetMediaAccess();
    void navigate({ href: target, replace: true });
  };
  return (
    <AuthShell title="Welcome back">
      <SignInChoices redirect={target} divider="or log in with email" onSignedIn={onSignedIn} />
    </AuthShell>
  );
}
